export default __webpack_public_path__ + "static/media/dwell.9232b511.png";